var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"empty-ph-small text-nowrap",class:{
    'moneyfield_crossout': _vm.crossout,
  }},[(_vm.value === undefined)?_c('span',[_vm._v("/")]):_c('span',{class:{
      'is-size-4': _vm.size === 'lg',
      'font-weight-bold': _vm.accent,
    }},[_vm._v(_vm._s(_vm.numToPriceFormat(_vm.value, _vm.lang, true)[0]))]),(!_vm.dynamicCents || _vm.numToPriceFormat(_vm.value, _vm.lang, true)[2] !== '00')?[_c('span',[_vm._v(_vm._s(_vm.numToPriceFormat(_vm.value, _vm.lang, true)[1]))]),_c('span',[_vm._v(_vm._s(_vm.numToPriceFormat(_vm.value, _vm.lang, true)[2]))])]:_vm._e(),_vm._v(" "+_vm._s(_vm.currency)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }